import axios from "axios";

const ApiInstance = axios.create();



// Response interceptor
// Track if session expiration alert is already shown
let isSessionExpiredHandled = false;

// Response interceptor
ApiInstance.interceptors.response.use(
  (response) => {
    handleAuthError(response);
    return response;
  },
  (error) => {
    if (error.response) handleAuthError(error.response);
    return Promise.reject(error);
  }
);

const handleAuthError = (response) => {
  const errorCode = response?.data?.error?.errorCode;
  const responseMessage = response?.data?.error?.responseMessage;
  const statusCode = response?.data?.statusCode;

  const isSessionExpired =
    errorCode === 22 ||
    (statusCode === 0 && errorCode === 22);

  if (isSessionExpired && !isSessionExpiredHandled) {
    isSessionExpiredHandled = true; // Prevent further triggers

    clearAuthData();
    if (responseMessage === "Your session has expired due to login in another device.") {
      setTimeout(() => {
        alert("Your session has expired, please login again.");
        window.location.href = '/';
      }, 100);
    }

  }
};

const clearAuthData = () => {
  localStorage.clear();
  document.cookie.split(";").forEach(cookie => {
    const [name] = cookie.trim().split("=");
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  });
};

export default ApiInstance;
